import { useEffect } from "react";
import illustration from "../Assets/Images/Illustration.svg";
import "../Css/Main.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Particle from "../Components/Particles";
import { Link } from "react-router-dom";

const HomeImg = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      offset: 200,
    });
  }, []);
  return (
    <>
      <Particle />
      <div className="relative bg-night web3-grid-bg overflow-hidden pt-28 sm:pt-32 lg:pt-40 pb-16 sm:pb-20 lg:pb-24">
        <div className="glow-orb w-[420px] h-[420px] bg-neonPurple/30 -top-32 -left-32"></div>
        <div className="glow-orb w-[380px] h-[380px] bg-customRed/20 top-1/3 right-0"></div>
        <div className="glow-orb w-[300px] h-[300px] bg-neonCyan/20 bottom-0 left-1/3"></div>
        <div className="relative max-w-[1240px] mx-auto grid lg:grid-cols-2 gap-10 items-center p-4">
          <div className="flex flex-col justify-center">
            <div className="inline-flex items-center gap-2 self-start rounded-full border border-white/15 bg-white/5 px-4 py-1.5 mb-6 backdrop-blur-md">
              <span className="h-2 w-2 rounded-full bg-customRed animate-pulse"></span>
              <span className="text-sm text-gray-300 tracking-wide">
                 Custom· AI · Software Solutions
              </span>
            </div>
            <h1
              data-aos="fade-right"
              className="text-white text-3xl sm:text-4xl lg:text-6xl font-extrabold leading-tight"
            >
              Spark Your Evolution with{" "}
              <span className="text-gradient">SpaceX Pakistan's</span>{" "}
              Solutions
            </h1>
            <p className="text-gray-300 text-base sm:text-lg lg:text-xl pt-4 sm:pt-6 max-w-xl">
              As an accomplished blockchain development company, SpaceX is
              steadfast in providing our clients with top-notch Web3 solutions
              of the highest quality.
            </p>
            <div className="flex flex-wrap gap-4 pt-8">
              <Link to="/contactUs">
                <button className="bg-customRed neon-btn text-white px-8 py-3 rounded-full font-bold hover:scale-105 transition ease-in-out">
                  Book Free Consultation
                </button>
              </Link>
              <Link to="/services">
                <button className="text-white px-8 py-3 rounded-full font-bold border border-white/20 bg-white/5 backdrop-blur-md hover:bg-white/10 hover:scale-105 transition ease-in-out">
                  Explore Services
                </button>
              </Link>
            </div>
          </div>
          <div data-aos="fade-left" className="flex justify-center">
            <img
              className="w-full max-w-md sm:max-w-lg h-auto max-h-64 sm:max-h-80 lg:max-h-96 animate-float drop-shadow-[0_0_45px_rgba(139,92,246,0.45)]"
              src={illustration}
              alt="Web3 illustration"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeImg;
